(() => {
  'use strict';
  if (window.TDMyPhone) return;
  const KEY = 'td-my-phone', FILTER_KEY = 'td-my-phone-filter', EVENT = 'td:phone-change';
  const ctx = window.TDMyPhoneContext || {};
  const PHONES = [
    ['apple', 'iphone-18-pro-max', 'iPhone 18 Pro Max'], ['apple', 'iphone-18-pro', 'iPhone 18 Pro'], ['apple', 'iphone-duo', 'iPhone Duo'],
    ['apple', 'iphone-17-pro-max', 'iPhone 17 Pro Max'], ['apple', 'iphone-17-pro', 'iPhone 17 Pro'], ['apple', 'iphone-air', 'iPhone Air'], ['apple', 'iphone-17', 'iPhone 17'],
    ['apple', 'iphone-16-pro-max', 'iPhone 16 Pro Max'], ['apple', 'iphone-16-pro', 'iPhone 16 Pro'], ['apple', 'iphone-16-plus', 'iPhone 16 Plus'], ['apple', 'iphone-16', 'iPhone 16'], ['apple', 'iphone-16e', 'iPhone 16e'],
    ['apple', 'iphone-15-pro-max', 'iPhone 15 Pro Max'], ['apple', 'iphone-15-pro', 'iPhone 15 Pro'], ['apple', 'iphone-15-plus', 'iPhone 15 Plus'], ['apple', 'iphone-15', 'iPhone 15'],
    ['apple', 'iphone-14-pro-max', 'iPhone 14 Pro Max'], ['apple', 'iphone-14-pro', 'iPhone 14 Pro'], ['apple', 'iphone-14-plus', 'iPhone 14 Plus'], ['apple', 'iphone-14', 'iPhone 14'],
    ['apple', 'iphone-13-pro-max', 'iPhone 13 Pro Max'], ['apple', 'iphone-13-pro', 'iPhone 13 Pro'], ['apple', 'iphone-13', 'iPhone 13'], ['apple', 'iphone-13-mini', 'iPhone 13 mini'],
    ['samsung', 'galaxy-s26-ultra', 'Galaxy S26 Ultra'], ['samsung', 'galaxy-s26-plus', 'Galaxy S26+'], ['samsung', 'galaxy-s26', 'Galaxy S26'], ['samsung', 'galaxy-s26-fe', 'Galaxy S26 FE'],
    ['samsung', 'galaxy-s25-ultra', 'Galaxy S25 Ultra'], ['samsung', 'galaxy-s25-edge', 'Galaxy S25 Edge'], ['samsung', 'galaxy-s25-plus', 'Galaxy S25+'], ['samsung', 'galaxy-s25', 'Galaxy S25'], ['samsung', 'galaxy-s25-fe', 'Galaxy S25 FE'],
    ['samsung', 'galaxy-s24-ultra', 'Galaxy S24 Ultra'], ['samsung', 'galaxy-s24-plus', 'Galaxy S24+'], ['samsung', 'galaxy-s24', 'Galaxy S24'], ['samsung', 'galaxy-s24-fe', 'Galaxy S24 FE'],
    ['samsung', 'galaxy-z-fold7', 'Galaxy Z Fold7'], ['samsung', 'galaxy-z-flip7', 'Galaxy Z Flip7'], ['samsung', 'galaxy-z-fold6', 'Galaxy Z Fold6'], ['samsung', 'galaxy-z-flip6', 'Galaxy Z Flip6'],
    ['samsung', 'galaxy-z-fold5', 'Galaxy Z Fold5'], ['samsung', 'galaxy-z-flip5', 'Galaxy Z Flip5']
  ].map(([brand, id, label]) => ({ brand, id, label }));
  const byId = new Map(PHONES.map((phone) => [phone.id, phone]));
  const IPHONE_SUFFIX = new Set(['pro', 'max', 'plus', 'mini']);
  const GALAXY_SUFFIX = new Set(['plus', 'ultra', 'fe', 'edge']);
  const isPhoneId = (id) => /^(iphone|galaxy)-[a-z0-9-]+$/.test(String(id || ''));

  /* Reads the phone models a product is made for from its handle,
     e.g. "...-iphone-18-pro-max-iphone-17-pro-max-..." → both models.
     An empty list means the product is universal (charger, cable…). */
  const parse = (handle) => {
    const t = String(handle || '').toLowerCase().split('-'), out = new Set();
    for (let i = 0; i < t.length; i++) {
      if (t[i] === 'iphone') {
        let j = i + 1;
        while (j < t.length) {
          const base = t[j];
          if (base === 'air' || base === 'duo') { out.add('iphone-' + base); j++; break; }
          if (!/^\d{2}e?$/.test(base)) break;
          if (t[j + 1] === 'air') { out.add('iphone-air'); j += 2; continue; }
          const parts = [base];
          let k = j + 1;
          while (k < t.length && IPHONE_SUFFIX.has(t[k])) parts.push(t[k++]);
          out.add('iphone-' + parts.join('-'));
          j = t[k] === 'iphone' ? k + 1 : k;
        }
        i = j - 1;
      } else if (t[i] === 'galaxy') {
        const next = t[i + 1] || '';
        if (next === 'z' && /^(fold|flip)\d+$/.test(t[i + 2] || '')) { out.add('galaxy-z-' + t[i + 2]); i += 2; continue; }
        if (/^[sa]\d{2}$/.test(next)) {
          const parts = [next];
          let k = i + 2;
          while (k < t.length && GALAXY_SUFFIX.has(t[k])) parts.push(t[k++]);
          out.add('galaxy-' + parts.join('-'));
          i = k - 1;
        }
      }
    }
    return [...out];
  };
  const labelFor = (id) => byId.get(id)?.label || id.replace(/^iphone-/, 'iPhone ').replace(/^galaxy-z-/, 'Galaxy Z ').replace(/^galaxy-/, 'Galaxy ')
    .replace(/-/g, ' ').replace(/\b(pro|max|plus|mini|ultra|edge|fold|flip)/g, (s) => s[0].toUpperCase() + s.slice(1)).replace(/\bfe\b/, 'FE').replace(/ ([sa])(\d)/, (m, a, b) => ' ' + a.toUpperCase() + b);
  const store = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { value == null ? localStorage.removeItem(key) : localStorage.setItem(key, value); } catch { /* storage unavailable */ } }
  };
  const get = () => { const id = store.get(KEY); return id && /^[a-z0-9-]{3,40}$/.test(id) ? id : null; };
  const set = (id) => {
    const value = id && /^[a-z0-9-]{3,40}$/.test(id) ? id : null;
    store.set(KEY, value);
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { id: value } }));
  };
  const filterOn = () => store.get(FILTER_KEY) !== '0';
  const compatible = (handle, id = get()) => { const models = parse(handle); return models.length ? (id ? models.includes(id) : null) : 'universal'; };
  const el = (tag, attrs = {}, children = []) => {
    const node = document.createElement(tag);
    for (const [key, value] of Object.entries(attrs)) {
      if (key === 'text') node.textContent = value; else if (key === 'class') node.className = value; else if (value !== false && value != null) node.setAttribute(key, value === true ? '' : value);
    }
    for (const child of [].concat(children)) if (child) node.append(child);
    return node;
  };
  const phoneIcon = () => { const span = el('span', { class: 'td-mp-icon', 'aria-hidden': 'true' }); span.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="6.5" y="2.5" width="11" height="19" rx="2.6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M10.5 18.5h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'; return span; };
  const fittingUrl = (phone, handle) => {
    const url = new URL(ctx.fittingUrl || '/pages/fitting-room', location.origin);
    if (phone) url.searchParams.set('phone', phone);
    if (handle) url.searchParams.set('case', handle);
    return url.pathname + url.search;
  };
  /* Every phone-specific product carries a tag with the phone name ("iPhone 15 Pro");
     its handle equals the phone id, so /collections/<handle>/<id> is filtered by Shopify
     across the whole catalog, with correct pagination and counts. */
  const root = (window.Shopify?.routes?.root || '/');
  const allUrl = (id) => root + 'collections/all/' + id;
  const collectionUrl = (tag) => {
    const url = new URL((ctx.collectionUrl || '') + (tag ? '/' + tag : ''), location.origin);
    const params = new URLSearchParams(location.search);
    params.delete('page');
    params.delete('td_phone');
    const query = params.toString();
    return url.pathname + (query ? '?' + query : '');
  };
  const canFilterCollection = () => ctx.pageType === 'collection' && !!ctx.phoneFilter && !!ctx.collectionUrl;
  const currentTag = () => (isPhoneId(ctx.currentTag) ? ctx.currentTag : null);
  /* Sends a phone-specific collection to its filtered (or unfiltered) URL. Returns true when navigating. */
  const syncCollection = () => {
    if (!canFilterCollection()) return false;
    if (ctx.currentTag && !isPhoneId(ctx.currentTag)) return false;
    const id = get(), want = id && filterOn() ? id : null;
    if (want === currentTag()) return false;
    location.replace(collectionUrl(want));
    return true;
  };
  const tryonFor = (handle) => (ctx.tryon || []).find((entry) => entry.handle === handle);
  const tryonPhones = new Set(ctx.fittingPhones || []);

  /* ---------- picker dialog ---------- */
  let dialog;
  const openPicker = () => {
    if (!dialog) {
      const select = el('select', { class: 'td-mp-select', id: 'td-mp-select' }, [el('option', { value: '', text: 'Alege modelul…' })]);
      for (const [brand, name] of [['apple', 'Apple'], ['samsung', 'Samsung']]) {
        const group = el('optgroup', { label: name });
        PHONES.filter((phone) => phone.brand === brand).forEach((phone) => group.append(el('option', { value: phone.id, text: phone.label })));
        select.append(group);
      }
      const save = el('button', { type: 'button', class: 'td-mp-btn td-mp-btn--primary', text: 'Salvează' });
      const clear = el('button', { type: 'button', class: 'td-mp-btn', text: 'Nu mai filtra' });
      const close = el('button', { type: 'button', class: 'td-mp-close', 'aria-label': 'Închide', text: '×' });
      const tryon = el('a', { class: 'td-mp-link', href: fittingUrl(), text: 'Probează accesoriile în 3D →' });
      dialog = el('dialog', { class: 'td-mp-dialog', 'aria-labelledby': 'td-mp-title' }, [
        close,
        el('span', { class: 'td-mp-kicker', text: 'TECHDEALER' }),
        el('h2', { id: 'td-mp-title', text: 'Telefonul meu' }),
        el('p', { text: 'Îți arătăm peste tot doar huse și accesorii care se potrivesc telefonului tău.' }),
        el('label', { for: 'td-mp-select', class: 'visually-hidden', text: 'Modelul telefonului' }), select,
        el('div', { class: 'td-mp-actions' }, [save, clear]), tryon
      ]);
      save.addEventListener('click', () => { if (select.value) { store.set(FILTER_KEY, '1'); set(select.value); } dialog.close(); });
      clear.addEventListener('click', () => { set(null); dialog.close(); });
      close.addEventListener('click', () => dialog.close());
      select.addEventListener('change', () => { tryon.setAttribute('href', fittingUrl(tryonPhones.has(select.value) ? select.value : '')); });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      document.body.append(dialog);
    }
    const select = dialog.querySelector('select');
    select.value = get() || '';
    dialog.querySelector('.td-mp-link').setAttribute('href', fittingUrl(tryonPhones.has(select.value) ? select.value : ''));
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    select.focus();
  };

  /* ---------- floating chip ---------- */
  let chip;
  const renderChip = () => {
    if (ctx.isFittingRoom) return;
    if (!chip) {
      chip = el('button', { type: 'button', class: 'td-mp-chip' });
      chip.addEventListener('click', openPicker);
      document.body.append(chip);
    }
    const id = get();
    chip.replaceChildren(phoneIcon(), el('span', { class: 'td-mp-chip-label', text: id ? labelFor(id) : 'Telefonul meu' }), el('span', { class: 'td-mp-chip-edit', text: id ? 'Schimbă' : 'Alege' }));
    chip.classList.toggle('is-set', !!id);
    chip.setAttribute('aria-label', id ? `Telefonul meu: ${labelFor(id)}. Schimbă` : 'Alege telefonul tău');
  };

  /* ---------- collection / search pages ---------- */
  let bar, scheduled = false;
  const cardHandle = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    const match = link && new URL(link.getAttribute('href'), location.origin).pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const placeBar = (cards) => {
    if (!bar) bar = el('div', { class: 'td-mp-bar', role: 'region', 'aria-label': 'Filtru după telefon' });
    const anchor = cards.length ? (cards[0].closest('.product-grid') || cards[0].closest('ul') || cards[0].parentElement)
      : document.querySelector('#MainContent .product-grid, #MainContent .collection-wrapper, #MainContent [class*="empty"]');
    if (anchor && bar.nextElementSibling !== anchor) anchor.parentElement.insertBefore(bar, anchor);
    return !!anchor;
  };
  const changeButton = (id) => {
    const change = el('button', { type: 'button', class: 'td-mp-btn', text: id ? 'Schimbă telefonul' : 'Alege telefonul' });
    change.addEventListener('click', openPicker);
    return change;
  };
  /* Phone-specific collection: Shopify already filtered the list by tag. */
  const applyFilteredCollection = (cards) => {
    const id = get(), tag = currentTag();
    for (const card of cards) {
      (card.closest('.product-grid__item, li') || card).classList.remove('td-mp-hidden');
      card.classList.remove('td-mp-dim');
      card.querySelector(':scope > .td-mp-badge')?.remove();
    }
    if (!placeBar(cards)) return;
    if (!id) {
      bar.replaceChildren(phoneIcon(), el('p', {}, [el('strong', { text: 'Ce telefon ai? ' }), document.createTextNode('Îți arătăm doar ce i se potrivește.')]), changeButton(null));
      return;
    }
    if (tag) {
      const count = Number(ctx.collectionCount || cards.length);
      const all = el('button', { type: 'button', class: 'td-mp-btn', text: 'Arată toate produsele' });
      all.addEventListener('click', () => { store.set(FILTER_KEY, '0'); location.assign(collectionUrl(null)); });
      const parts = [phoneIcon(), el('p', {}, [el('span', { text: 'Afișăm doar produsele pentru ' }), el('strong', { text: labelFor(tag) }), el('small', { text: ` · ${count} ${count === 1 ? 'produs' : 'produse'}` })]), all, changeButton(id)];
      if (!count) parts.push(el('p', { class: 'td-mp-empty', text: `Nu avem încă produse din această categorie pentru ${labelFor(tag)}.` }));
      bar.replaceChildren(...parts);
      return;
    }
    const only = el('button', { type: 'button', class: 'td-mp-btn td-mp-btn--primary', text: `Doar pentru ${labelFor(id)}` });
    only.addEventListener('click', () => { store.set(FILTER_KEY, '1'); location.assign(collectionUrl(id)); });
    bar.replaceChildren(phoneIcon(), el('p', {}, [el('span', { text: 'Telefonul tău: ' }), el('strong', { text: labelFor(id) }), el('small', { text: ' · vezi toate produsele din categorie' })]), only, changeButton(id));
  };
  const applyListing = () => {
    scheduled = false;
    const cards = [...document.querySelectorAll('#MainContent product-card')];
    if (canFilterCollection()) { applyFilteredCollection(cards); return; }
    if (!cards.length) { bar?.remove(); bar = null; return; }
    const id = get(), canHide = ctx.pageType === 'search', filtering = !!id && canHide && filterOn();
    let fit = 0, universal = 0, hidden = 0;
    for (const card of cards) {
      const item = card.closest('.product-grid__item, li') || card;
      const result = compatible(cardHandle(card), id);
      const mismatch = !!id && result === false;
      item.classList.toggle('td-mp-hidden', filtering && mismatch);
      card.classList.toggle('td-mp-dim', !filtering && mismatch);
      let badge = card.querySelector(':scope > .td-mp-badge');
      if (id && result === true) {
        if (!badge) { badge = el('span', { class: 'td-mp-badge', 'aria-hidden': 'true' }); card.prepend(badge); }
        badge.textContent = '✓ Compatibil';
      } else badge?.remove();
      if (result === true) fit++; else if (result === 'universal') universal++;
      if (filtering && mismatch) hidden++;
    }
    if (!placeBar(cards)) return;
    if (!id) {
      bar.replaceChildren(phoneIcon(), el('p', {}, [el('strong', { text: 'Ce telefon ai? ' }), document.createTextNode('Îți arătăm doar ce i se potrivește.')]), changeButton(null));
      return;
    }
    const summary = el('p', {}, [el('span', { text: 'Telefonul tău: ' }), el('strong', { text: labelFor(id) }), el('small', { text: ` · ${fit} potrivite${universal ? `, ${universal} universale` : ''}${hidden ? ` · ${hidden} ascunse` : ''} pe această pagină` })]);
    const parts = [phoneIcon(), summary];
    if (canHide) {
      const toggle = el('input', { type: 'checkbox', id: 'td-mp-only', checked: filtering });
      toggle.addEventListener('change', () => { store.set(FILTER_KEY, toggle.checked ? '1' : '0'); applyListing(); });
      parts.push(el('label', { class: 'td-mp-toggle', for: 'td-mp-only' }, [toggle, el('span', { text: 'Doar compatibile' })]));
    }
    parts.push(el('a', { class: 'td-mp-btn td-mp-btn--primary', href: allUrl(id), text: `Toate produsele pentru ${labelFor(id)} →` }));
    parts.push(changeButton(id));
    if (filtering && fit + universal === 0) {
      parts.push(el('p', { class: 'td-mp-empty', text: `Nimic pentru ${labelFor(id)} pe această pagină. Vezi lista completă cu butonul de mai sus.` }));
    }
    bar.replaceChildren(...parts);
  };
  /* Cards re-render while the grid loads (infinite scroll, filters), so run once now and once when it settles. */
  let settle;
  const scheduleListing = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(applyListing); }
    clearTimeout(settle);
    settle = setTimeout(applyListing, 400);
  };

  /* ---------- product page ---------- */
  let box;
  const applyProduct = () => {
    const handle = ctx.productHandle;
    if (!handle) return;
    const tagged = (ctx.productPhones || []).filter(isPhoneId);
    const models = tagged.length ? tagged : parse(handle), tryon = tryonFor(handle), id = get();
    if (!models.length && !tryon) { box?.remove(); return; }
    const anchor = document.querySelector('#MainContent product-form-component, #MainContent form[action*="/cart/add"]');
    if (!anchor) return;
    if (!box) { box = el('div', { class: 'td-mp-product', role: 'note' }); anchor.parentElement.insertBefore(box, anchor); }
    const parts = [];
    if (models.length) {
      let status;
      if (!id) {
        const pick = el('button', { type: 'button', class: 'td-mp-inline', text: 'Setează telefonul tău' });
        pick.addEventListener('click', openPicker);
        status = el('p', { class: 'td-mp-status' }, [document.createTextNode('Nu știi sigur dacă se potrivește? '), pick]);
      } else if (models.includes(id)) {
        status = el('p', { class: 'td-mp-status is-ok' }, [el('strong', { text: '✓ Se potrivește' }), document.createTextNode(` cu telefonul tău (${labelFor(id)}).`)]);
      } else {
        status = el('p', { class: 'td-mp-status is-warn' }, [el('strong', { text: '⚠ Nu se potrivește' }), document.createTextNode(` cu telefonul tău (${labelFor(id)}). `), el('a', { href: allUrl(id), text: `Vezi produsele pentru ${labelFor(id)} →` })]);
      }
      parts.push(el('p', { class: 'td-mp-models' }, [el('span', { text: 'Compatibil cu: ' }), el('strong', { text: models.map(labelFor).join(', ') })]), status);
    }
    if (tryon) {
      const phone = id && tryon.phones.includes(id) ? id : tryon.phones[0];
      parts.push(el('a', { class: 'td-mp-tryon', href: fittingUrl(phone, handle) }, [phoneIcon(), el('span', { text: 'Probează husa în 3D pe telefon' })]));
    }
    box.replaceChildren(...parts);
  };

  const refresh = () => {
    if (syncCollection()) return;
    renderChip();
    if (ctx.pageType === 'collection' || ctx.pageType === 'search') applyListing();
    if (ctx.pageType === 'product') applyProduct();
  };
  const init = () => {
    const fromUrl = new URLSearchParams(location.search).get('td_phone');
    if (fromUrl && /^[a-z0-9-]{3,40}$/.test(fromUrl)) {
      store.set(FILTER_KEY, '1'); store.set(KEY, fromUrl);
      /* Links like /collections/huse?td_phone=… come from the fitting room. */
      if (ctx.pageType === 'collection' && !canFilterCollection()) { location.replace(allUrl(fromUrl)); return; }
    }
    if (syncCollection()) return;
    refresh();
    if (ctx.pageType === 'collection' || ctx.pageType === 'search') setTimeout(applyListing, 800);
    document.addEventListener(EVENT, refresh);
    window.addEventListener('storage', (event) => { if (event.key === KEY || event.key === FILTER_KEY) refresh(); });
    if (ctx.pageType === 'collection' || ctx.pageType === 'search') {
      const main = document.querySelector('#MainContent');
      if (main) new MutationObserver((records) => {
        const relevant = records.some((r) => !(r.target.nodeType === 1 && r.target.closest('.td-mp-bar, .td-mp-badge')) && [...r.addedNodes].some((n) => n.nodeType === 1 && !n.matches('.td-mp-badge, .td-mp-bar')));
        if (relevant) scheduleListing();
      }).observe(main, { childList: true, subtree: true });
    }
  };
  window.TDMyPhone = { phones: PHONES, parse, labelFor, get, set, compatible, open: openPicker, event: EVENT, allUrl };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
